"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signOutRequestSuccessAction = exports.signOutRequestFailAction = exports.signOutRequestAction = exports.signInRequestSuccessAction = exports.signInRequestFailAction = exports.signInRequestAction = exports.setLoadingProcessAction = exports.setAvailableMerchants = exports.selectRedirectTo401 = exports.selectProfile = exports.selectIsLoaded = exports.selectIsAuth = exports.selectInProcess = exports.selectInLoadingProcess = exports.selectError = exports.selectAvailableMerchants = exports.resetStateAction = exports.resetErrorAction = exports.reducer = exports.name = exports.getProfileRequestSuccessAction = exports.getProfileRequestFailAction = exports.getProfileRequestAction = exports.changeTypeRequestSuccessAction = exports.changeTypeRequestFailAction = exports.changeTypeRequestAction = exports.changeMerchantAction = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _toolkit = require("@reduxjs/toolkit");

var REDUCER_NAME = 'widget/profile';
var initialState = {
  error: null,
  profile: null,
  merchants: [],
  isAuth: false,
  isLoaded: false,
  inProcess: false,
  inLoadingProcess: false,
  redirectTo401: false
};
var slice = (0, _toolkit.createSlice)({
  name: REDUCER_NAME,
  initialState: initialState,
  reducers: {
    resetStateAction: function resetStateAction(state) {
      state['error'] = null;
      state['profile'] = null;
      state['merchants'] = [];
      state['isAuth'] = false;
      state['inProcess'] = false;
      state['inLoadingProcess'] = false;
      state['redirectTo401'] = false;
    },
    setLoadingProcessAction: function setLoadingProcessAction(state, _ref) {
      var payload = _ref.payload;
      state['inLoadingProcess'] = payload;
    },
    resetErrorAction: function resetErrorAction(state) {
      state['error'] = null;
    },
    isLoadedAction: function isLoadedAction(state) {
      state['isLoaded'] = true;
    },
    signInRequestAction: function signInRequestAction(state) {
      state['inProcess'] = true;
    },
    signInRequestFailAction: function signInRequestFailAction(state, _ref2) {
      var payload = _ref2.payload;
      state['inProcess'] = false;
      state['error'] = payload;
    },
    signInRequestSuccessAction: function signInRequestSuccessAction(state, _ref3) {
      var payload = _ref3.payload;
      state['inProcess'] = false;
      state['profile'] = payload;
    },
    getProfileRequestAction: function getProfileRequestAction(state) {
      state['inProcess'] = true;
    },
    getProfileRequestFailAction: function getProfileRequestFailAction(state) {
      state['inProcess'] = false;
    },
    getProfileRequestSuccessAction: function getProfileRequestSuccessAction(state, _ref4) {
      var payload = _ref4.payload;
      state['profile'] = payload;
      state['inProcess'] = false;
    },
    signOutRequestAction: function signOutRequestAction(state) {
      state['inProcess'] = false;
    },
    signOutRequestFailAction: function signOutRequestFailAction(state) {
      state['inProcess'] = false;
    },
    signOutRequestSuccessAction: function signOutRequestSuccessAction(state) {
      state['inProcess'] = false;
    },
    setAvailableMerchants: function setAvailableMerchants(state, _ref5) {
      var payload = _ref5.payload;
      state['merchants'] = payload;
    },
    changeTypeRequestAction: function changeTypeRequestAction(state) {
      state['inProcess'] = true;
    },
    changeTypeRequestFailAction: function changeTypeRequestFailAction(state, _ref6) {
      var payload = _ref6.payload;
      state['error'] = payload;
      state['inProcess'] = false;
    },
    changeTypeRequestSuccessAction: function changeTypeRequestSuccessAction(state, _ref7) {
      var payload = _ref7.payload;
      state['profile'] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state['profile']), {}, {
        merchant: payload
      });
      state['merchants'] = [payload];
      state['inProcess'] = false;
    },
    changeMerchantAction: function changeMerchantAction(state, _ref8) {
      var payload = _ref8.payload;
      state['profile'] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, state['profile']), {}, {
        merchant: payload
      });
    }
  }
});
var _slice$actions = slice['actions'],
    setLoadingProcessAction = _slice$actions.setLoadingProcessAction,
    resetStateAction = _slice$actions.resetStateAction,
    resetErrorAction = _slice$actions.resetErrorAction,
    changeMerchantAction = _slice$actions.changeMerchantAction,
    setAvailableMerchants = _slice$actions.setAvailableMerchants,
    signInRequestAction = _slice$actions.signInRequestAction,
    signInRequestFailAction = _slice$actions.signInRequestFailAction,
    signInRequestSuccessAction = _slice$actions.signInRequestSuccessAction,
    getProfileRequestAction = _slice$actions.getProfileRequestAction,
    getProfileRequestFailAction = _slice$actions.getProfileRequestFailAction,
    getProfileRequestSuccessAction = _slice$actions.getProfileRequestSuccessAction,
    signOutRequestAction = _slice$actions.signOutRequestAction,
    signOutRequestFailAction = _slice$actions.signOutRequestFailAction,
    signOutRequestSuccessAction = _slice$actions.signOutRequestSuccessAction,
    changeTypeRequestAction = _slice$actions.changeTypeRequestAction,
    changeTypeRequestFailAction = _slice$actions.changeTypeRequestFailAction,
    changeTypeRequestSuccessAction = _slice$actions.changeTypeRequestSuccessAction;
exports.changeTypeRequestSuccessAction = changeTypeRequestSuccessAction;
exports.changeTypeRequestFailAction = changeTypeRequestFailAction;
exports.changeTypeRequestAction = changeTypeRequestAction;
exports.signOutRequestSuccessAction = signOutRequestSuccessAction;
exports.signOutRequestFailAction = signOutRequestFailAction;
exports.signOutRequestAction = signOutRequestAction;
exports.getProfileRequestSuccessAction = getProfileRequestSuccessAction;
exports.getProfileRequestFailAction = getProfileRequestFailAction;
exports.getProfileRequestAction = getProfileRequestAction;
exports.signInRequestSuccessAction = signInRequestSuccessAction;
exports.signInRequestFailAction = signInRequestFailAction;
exports.signInRequestAction = signInRequestAction;
exports.setAvailableMerchants = setAvailableMerchants;
exports.changeMerchantAction = changeMerchantAction;
exports.resetErrorAction = resetErrorAction;
exports.resetStateAction = resetStateAction;
exports.setLoadingProcessAction = setLoadingProcessAction;

var selectError = function selectError(state) {
  return state[REDUCER_NAME]['error'];
};

exports.selectError = selectError;

var selectIsAuth = function selectIsAuth(state) {
  return state[REDUCER_NAME]['isAuth'];
};

exports.selectIsAuth = selectIsAuth;

var selectProfile = function selectProfile(state) {
  return state[REDUCER_NAME]['profile'];
};

exports.selectProfile = selectProfile;

var selectIsLoaded = function selectIsLoaded(state) {
  return state[REDUCER_NAME]['isLoaded'];
};

exports.selectIsLoaded = selectIsLoaded;

var selectInProcess = function selectInProcess(state) {
  return state[REDUCER_NAME]['inProcess'];
};

exports.selectInProcess = selectInProcess;

var selectInLoadingProcess = function selectInLoadingProcess(state) {
  return state[REDUCER_NAME]['inLoadingProcess'];
};

exports.selectInLoadingProcess = selectInLoadingProcess;

var selectRedirectTo401 = function selectRedirectTo401(state) {
  return state[REDUCER_NAME]['redirectTo401'];
};

exports.selectRedirectTo401 = selectRedirectTo401;

var selectAvailableMerchants = function selectAvailableMerchants(state) {
  return state[REDUCER_NAME]['merchants'];
};

exports.selectAvailableMerchants = selectAvailableMerchants;
var name = slice['name'];
exports.name = name;
var reducer = slice['reducer'];
exports.reducer = reducer;